import React, { useEffect, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useLocation, useHistory } from 'react-router-dom';
import { IconButton, Icon, Grid, Button, Tooltip, Alert, Box, CircularProgress } from '@material-ui/core';
import { green, red } from '@material-ui/core/colors';
import TheatersIcon from '@material-ui/icons/Theaters';

import { toggleShowDialog } from '../../store/actions/dialog';
import { deletarCupomDeDesconto, getCuponsDoNegocio, getCupons } from '../../store/actions/cupomDeDesconto';
import TituloPagina from '../../components/layout/TituloPagina';
import moedaBr from '../../assets/js/moedaBr';
import DataTableComponent from '../../components/form/DataTableComponent';
import DialogAlert from '../../components/layout/DialogAlert';
import LoadingOverlay from '../../components/layout/LoadingOverlay';

const CupomDeDesconto = props => {

    const history = useHistory();
    const location = useLocation();
    const {
        cupons,
        toggleShowDialog,
        getCuponsDoNegocio,
        getCupons,
        deletarCupomDeDesconto,
        loading,
        user
    } = props
    const [toggleDeleteDialog, setToggleDeleteDialog] = useState(false);
    const { funcionarios, perfis } = user || [];
    const userStoreId = Array.isArray(funcionarios) && funcionarios.length > 0 ? funcionarios[0].idNegocio : null;
    const isPlatformAdmin = Array.isArray(perfis) && perfis.includes('ADMIN_APP');

    const columns = [
        {
            name: 'ID',
            selector: (row) => row.id,
            width: '70px',
            sortable: true,
        },
        {
            name: 'Código',
            selector: (row) => row.codigo,
            sortable: true,
        },
        {
            name: 'Tipo de Desconto',
            selector: (row) => (
                row.tipoDeDesconto === 'PORCENTAGEM' ? 'Porcentagem' : 'Valor Fixo'
            ),
            headerStyle: { whiteSpace: 'normal' },
            width: '170px',
            sortable: true,
        },
        {
            name: 'Estoque',
            selector: (row) => row.estoque,
            width: '110px',
            sortable: true,
        },
        {
            name: 'Data Início',
            selector: (row) => row.dataInicio,
            width: '140px',
            sortable: true,
        },
        {
            name: 'Data Término',
            selector: (row) => row.dataFim,
            width: '140px',
            sortable: true,
        },
        {
            name: 'Ativo',
            center: 'true',
            selector: (row) => (
                row.ativo ? <Icon fontSize='small' style={{ color: green[500] }}>check_circle</Icon> : <Icon fontSize='small' style={{ color: red[500] }}>cancel</Icon>
            ),
            width: '75px',
        },
        {
            name: 'Ações',
            center: 'true',
            cell: (row) => (
                <>
                    <Tooltip title='Detalhar Cupom' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="detalhar" size='small' color='secondary' onClick={() => handleDetalharCupom(row.id)}><Icon>search</Icon></IconButton>
                    </Tooltip>
                    <Tooltip title='Editar Cupom' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="editar" size='small' color='secondary' onClick={() => handleEditarCupom(row.id)}><Icon>edit</Icon></IconButton>
                    </Tooltip>
                    <Tooltip title='Desativar Cupom' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="excluir" size='small' color='secondary' onClick={() => handleDeletaProduto(row)}><Icon>delete</Icon></IconButton>
                    </Tooltip>
                </>
            ),
            width: '100px',
            
        }
    ];

    useEffect(() => {
        if (isPlatformAdmin) {
            getCupons();
        } else {
            getCuponsDoNegocio(userStoreId);
        }
    }, [getCuponsDoNegocio, userStoreId, isPlatformAdmin]);

    const handleDetalharCupom = (id) => {
        history.push({
            pathname: '/cupom-de-desconto/detalhar-cupom',
            state: {
                cupomId: id,
                from: window.location.pathname,
            },
        });
    }
    
    const handleEditarCupom = (id) => {
        history.push({
            pathname: '/cupom-de-desconto/editar-cupom',
            state: {
                cupomId: id,
                from: window.location.pathname,
            },
        });
    }

    const handleDeletaProduto = (row) => {
        toggleShowDialog(row);
        setToggleDeleteDialog(true);
    }

    const handleCancelarDelete = () => {
        setToggleDeleteDialog(false);
    }

    const handleConfirmarDelete = (idDialogShow) => {
        deletarCupomDeDesconto(idDialogShow);
        setToggleDeleteDialog(false);
    }

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, height: '70vh' }}>
                <CircularProgress size={48} />
            </Box>
        );
    }

    return (
        <>
            <TituloPagina titulo='Cupons de Desconto' subtitulo={new Date().toLocaleString('pt-BR')} />
            <Box sx={{ height: '70vh' }}>
               
                <DataTableComponent
                    columns={columns}
                    data={cupons}
                    visibleSearch={cupons && cupons.length > 0}
                    camposParaBusca={['codigo', 'tipoDeDesconto', 'valorDoDesconto']}
                />
                <Grid container >
                    <Button variant='contained' color='secondary' href='/cupom-de-desconto/cadastrar-cupom'>Adicionar Cupom</Button>
                </Grid>
            </Box>
            <DialogAlert
                title='Excluir Cupom de Desconto'
                okButton={true}
                labelOkButton='Confirmar'
                okButtonClick={handleConfirmarDelete}
                cancelButton={true}
                labelCancelButton='Cancelar'
                cancelButtonClick={handleCancelarDelete}
                openDialog={toggleDeleteDialog}>
                Tem certeza que deseja excluir o cupom?
            </DialogAlert>
        </>
    )
}

const mapStateToProps = state => ({
    cupons: state.cupomDeDesconto.cupons,
    idDialogShow: state.dialog.idDialogShow,
    loading: state.cupomDeDesconto.loading,
    processing: state.cupomDeDesconto.processing,
    user: state.auth.user,
})
const mapDispatchToProps = dispatch => bindActionCreators({
    toggleShowDialog,
    getCuponsDoNegocio,
    getCupons,
    deletarCupomDeDesconto,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CupomDeDesconto)